import { ComponentInstall } from "../../utils";
import Tab from "./src";
import TabPane from "./src/TabPane";

export default ComponentInstall(Tab, TabPane);
